import React, { Component } from 'react';
import classNames from 'classnames';
import 'styles/ServicesPage.css';
import TransitionGroup from 'react-transition-group/TransitionGroup';

import ServiceComponent from 'scripts/components/service';

const TweenMax = window.TweenMax;
var ga = window.ga;

class ServicesPage extends Component {
	constructor(props) {
		super(props);

		this.state = {
			activeService: 0,
			nextIndex: null,
			animating: false
		}


		this.services = [
			{
				img: require('../../assets/images/services_website.svg'),
				title: "Websites",
				id: 'websites',
				description: "Lightning-fast and silky-smooth.",
				bullets: [
					"Front & back end",
					"Pixel-perfect comp matching",
					"Experiential (3D, 60FPS animation, WebGL)",
					"WordPress (Clean & Custom)",
					"Custom CMS",
					"Apps & MVPs"
				],
				colors: {color1: "rgba(255,163,137,1)", color2: "rgba(206,56,125,1)"}
			},
			{
				img: require('../../assets/images/services_apps.svg'),
				title: "Native Apps",
				id: 'apps',
				description: "Flawless mobile, enabled by expertly designed frontends & data structures.",
				bullets: [
					"iOS/Android Native",
					"React Native",
					"MVPs",
					"System Architecture"
				],
				colors: {color1: "rgba(252,243,163,1)", color2: "rgba(253,122,74,1)"}
			},
			{
				img: require('../../assets/images/services_games.svg'),
				title: "Games",
				id: 'games',
				description: "Transform your awesome concept into a gripping game.",
				bullets: [
					"Web/iOS/Android Games",
					"Cutting-edge WebGL effects",
					"Unity",
					"PlayCanvas"
				],
				colors: {color1: "rgba(145,199,249,1)", color2: "rgba(41,107,199,1)"}
			},
			{
				img: require('../../assets/images/services_admin.svg'),
				title: "Server Admin",
				id: 'serveradmin',
				description: "From small updates to global scaling.",
				bullets: [
					"Server setup & installation",
					"Administration & scaling",
					"Routine development updates/maintenance",
					"Domain configuration"
				],
				colors: {color1: "rgba(85,229,212,1)", color2: "rgba(27,147,133,1)"}
			},
			{
				img: require('../../assets/images/services_banners.svg'),
				title: "Banners",
				id: 'banners',
				description: "Quickest turnaround and smoothest process.",
				bullets: [
					"DoubleClick Certified",
					"Rich Media Ads",
					"HTML5 Banners",
					"Facebook Canvas"
				],
				colors: {color1: "rgba(237,190,247,1)", color2: "rgba(93,90,211,1)"}
			},
			{
				img: require('../../assets/images/services_vr.svg'),
				title: "Virtual Reality",
				id: 'vr',
				description: "Creating mind-blowing and immersive experiences.",
				bullets: [
					"Oculus",
					"Vive",
					"Daydream",
					"Unity/UE4"
				],
				colors: {color1: "rgba(251,132,255,1)", color2: "rgba(95,140,253,1)"}
			}
		]

	}

	componentDidMount() {
	    ga('send', 'event', 'Services Page', 'Page View');
	}

	setActiveService = (index) => {
		if(this.state.activeService === index){
			return;
		}
		if (this.state.animating) {
			// console.log("SET FOR LATER", index)
			this.setState({nextIndex: index})
			return;
		}

		let current = this.services[this.state.activeService].colors;
		let obj = this.services[index].colors;
		let el = this.el;

		this.setState({activeService: index, animating: true})


		TweenMax.to(obj, 2,
		  {
		    colorProps:
			{
			    color1:obj.color1,
			    color2:obj.color2
			},
			onUpdate: upFn
		});


		function upFn() {
			// el.style.background = "-webkit-gradient(linear, left top, right top, color-stop(0%," + obj.color1 + ")color-stop(100%,"+ obj.color2 + ")";
			el.style.background = "-webkit-linear-gradient(left, " + obj.color1 + " 0%,"+ obj.color2 + " 100%)";

			// el.style.background = "linear-gradient(to right, " + obj.color1 + " 0%, "+ obj.color2 + " 100%)"
			// $(overlay)
			// .css({"background": "-moz-linear-gradient(-45deg, " + obj.color1 + " 0%, "+ obj.color2 + " 100%)"})
		 //    .css({"background": "-webkit-linear-gradient(-45deg, " + obj.color1 + " 0%, "+ obj.color2 + " 100%)"})
		 //    .css({"background": "-o-linear-gradient(-45deg, " + obj.color1 + " 0%, "+ obj.color2 + " 100%)"})
		 //    .css({"background": "-ms-linear-gradient(-45deg, " + obj.color1 + " 0%, "+ obj.color2 + " 100%)"})
		 //    .css({"background": "linear-gradient(135deg, " + obj.color1 + " 0%, "+ obj.color2 + " 100%)"})
		}
	}

	enableHover = () => {
		this.setState({animating: false}, () => {
			if(this.state.nextIndex !== null && this.state.nextIndex !== this.state.activeService){
				// console.log("NEXT", this.state.nextIndex)
				this.setActiveService(this.state.nextIndex)
			}
			this.setState({nextIndex: null})
		});

	}


	renderServiceList() {
		return this.services.map((service, i) => {
			let classes = classNames({
				"list-item": true,
				"stagger-in": true,
				'active': i === this.state.activeService
			})
			return (
				<li className={classes + " " + service.id} key={i}>
	      			<img src={service.img}  onMouseEnter={ () => { this.setActiveService(i) } }/>
	      			<p>{service.title}</p>
	      		</li>
			)
		});
	}



	renderActiveService() {
		return this.services.map((service, i) => {
			if(i == this.state.activeService){
				return (
					<ServiceComponent service={service} key={i} transitionEnd={this.enableHover}/>
				)
			} else {
				return null;
			}
		});
	}


  render() {
  	let { activeService } = this.state
  	let list = this.renderServiceList()

  	let service = this.renderActiveService()

  	let left = activeService*20;
  	let offset = activeService < 3 ? 6.7 + (4 - activeService*2) : 4.7

  	let leftStyles = {
  		'left': 'calc(' + left + '% + ' + offset + 'vw)'
  	}


    return (
    <div id="ServicesPage" ref={(el) => this.el = el} className={"active" + this.state.activeService}>
      	<div className="services-container">
	    	<div className="vert-center-container list">
	      		<div className="vert-center">
			      	<div className="container-list">
			      		<ul>
				      		{list}
			      		</ul>
			      		<div className="mobile-caret" style={leftStyles}/>
			      	</div>

		      	</div>
	      	</div>


	      	<div className="vert-center-container">
	      		<div className="vert-center">
			      	<div className="selected-service stagger-in">
			      		<TransitionGroup component="div" className="service-animation">
				      		{service}
			      		</TransitionGroup>
			      	</div>
			    </div>
			</div>




	    </div>


    </div>
    );
  }
}

export default ServicesPage;



// WEBPACK FOOTER //
// ./src/scripts/containers/ServicesPage.js